import React from "react";
import { Skeleton } from "antd";
import { createUseStyles } from "react-jss";

const UserListSkeleton = () => {
  const styles = useStyles();

  return (
    <div className={styles.seccolumn}>
      {[1, 2, 3, 4, 5, 6].map((index) => (
        <div key={index} className={styles.settingMainContainerUserBox}>
          <div className={styles.userCardSkeleton}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 15 }}>
              <Skeleton.Avatar active size={50} />
              <div style={{display:"flex", flexDirection:"column",  marginLeft: 15, flex: 1 }}>
                <Skeleton.Input active size={16} style={{ width: 150, marginBottom: 8 }} />
                <Skeleton.Input active size={14} style={{ width: 100 }} />
                <div style={{ display: "flex", alignItems: "center",   marginTop:10, gap:10 }}>
                    <Skeleton.Input active size={14} style={{ width: 60 }} />
                    <Skeleton.Button active size={14} style={{ width: 80 }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

const useStyles = createUseStyles({
  seccolumn: {
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  settingMainContainerUserBox: {
    display: "flex",
    minWidth: "49%",
    width: "min-content",
  },
  userCardSkeleton: {
    width: "100%",
    background: "#fff",
    borderRadius: 10,
    border: "1px solid #e7e7e7",
    padding: 20,
    marginBottom: 15,
  },
  "@media (max-width: 1280px)": {
    seccolumn: {
      display: "block",
    },
    settingMainContainerUserBox: {
      width: "auto",
    },
  },
});

export default UserListSkeleton; 